import * as React from 'react'

function Unmute(props) {
  const {onClick, isMuted} = props;
  const [show, setShow] = React.useState(true);
  const [expanded, setExpanded] = React.useState(false);

  React.useEffect(() => {
    const timeouts = [];

    /* Stack timeout delays */
    timeouts.push(setTimeout(() => setExpanded(true), 3000));
    timeouts.push(setTimeout(() => setExpanded(false), 7000));
    timeouts.push(setTimeout(() => setShow(false), 17000));

    return () => {
      timeouts.map(t => clearTimeout(t));
    }
  }, [])

  return (
      <div onClick={onClick} className={`enable-sound-button ${show ? "show" : ""} ${expanded ? "expanded" : ""} ${isMuted ? '' : 'has_volume'}`}>
          <span>Slå på ljud</span>
      </div>
  )
}

export default Unmute;